// extracted by mini-css-extract-plugin
export default {"screenSm":"992px","eigengrau":"#101828","paleSky":"#667085","logout":"styles_logout__zfSBh","icon":"styles_icon__WC2uW"};